// extracted by mini-css-extract-plugin
module.exports = {"intro":"__8WEd0JEE","hide":"xCvr_v2n","hasMoreIntro":"__9cMeEEDY","contain":"kRTfOPkG","extraIntro":"os6ha_F_","introWrap":"UGqT4yxD","more":"d5rrtXY4"};